import React from 'react';
import TrainingPage from '../components/training/TrainingPage';
import trainingContent from '../config/trainingContent';

export default function AmazonQTraining() {
  return (
    <TrainingPage
      seo={{
        title: "Amazon Q Training for Data and BI Teams | Eagentix",
        description: "1-day onsite Amazon Q training against your own connected sources. Business Q&A, data discovery, dashboard drafting and the verification step most training skips."
      }}
      content={trainingContent.amazonq}
    />
  );
}
